/**
 * Markup for the about us modal
 * @returns string
 */
export default function getBooksModal() {
  return `
  <div class="bfe-modal__content">
        <div class="bfe-modal__image">
        <img src="/_redesign/assets/img/books-for-email/pic_books-success.webp" alt="Books" width="275" height="290" loading="lazy">
      </div>
      <div>
        <div class="bfe-modal__title">
          Check your mail
        </div>
        <div class="bfe-modal__text">
          <img src="/_redesign/assets/img/books-for-email/logo-amazon.svg" style="display:inline;margin-bottom:-13px;" alt="Amazon" loading="lazy" width="97" height="27" /> e-books are yours now
        </div>
        <div class="bfe-modal__card">
          <div class="bfe-modal__card-heading">
            Get your paper done by a pro writer
          </div>
          <div class="bfe-modal__writers">
            <img class="bfe-modal__writer-avatar" src="https://essayshark.com/w3t_avatar/writer/416/techpro12x128.webp" alt="techpro12" title="techpro12" width="44" height="44" loading="lazy">
            <img class="bfe-modal__writer-avatar" src="https://essayshark.com/w3t_avatar/writer/291/aqademiar-tpnx128.webp" alt="qademiar-tpn" title="qademiar-tpn" width="44" height="44" loading="lazy">
            <img class="bfe-modal__writer-avatar" src="https://essayshark.com/w3t_avatar/writer/133/nunziolinx128.webp" alt="nunziolin" title="nunziolin" width="44" height="44" loading="lazy">
            <img class="bfe-modal__writer-avatar" src="https://essayshark.com/w3t_avatar/writer/248/cathykathyx128.webp" alt="cathykathy" title="cathykathy" width="44" height="44" loading="lazy">
          </div>
          <a href="/registration.html" class="button primary-light-blue">Find a writer <div class="button__arrow"></div></a>
        </div>
      </div>
    </div>
  `;
}
